// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"CampusMapList_searchbox__3irEf"};